export const binaryOptions: {name: string, value: boolean}[] = [
  {name: 'yes', value: true},
  {name: 'no', value: false},
];